import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CurrencySign } from 'src/utils/format';
import {
    SelectWrapper,
    DropdownWrapper,
    ChevronDownWrapper,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/Dropdown/Dropdown.style';

interface SelectOptionsType {
    key: number | string | undefined;
    name: string;
}

interface DropdownPropsType {
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    dropDownvalue: number | string;
    options: Array<SelectOptionsType>;
    currency?: string;
    placeholder?: string;
    dataTest?: string;
}

export const Dropdown = observer('Dropdown', (props: DropdownPropsType): React.ReactElement => {
    const { onChange, dropDownvalue, options, currency, placeholder, dataTest } = props;

    return (
        <SelectWrapper data-test='dropdown-processed'>
            <DropdownWrapper
                onChange={onChange}
                value={dropDownvalue === 0 ? undefined : dropDownvalue}
                data-test={dataTest}
            >
                <option
                    value=''
                    disabled
                    hidden
                >
                    {placeholder}
                </option>
                {options.length > 0 ? (
                    <>
                        {options.map((option: SelectOptionsType) => {
                            const key = option.key;
                            const name = option.name;

                            return (
                                <option
                                    key={key ?? name}
                                    value={key}
                                >
                                    {`${CurrencySign(currency)} ${name}`}
                                </option>
                            );
                        })}
                    </>
                ) : null}
            </DropdownWrapper>
            <ChevronDownWrapper />
        </SelectWrapper>
    );
});
